'use strict';

angular.module('mean.messages').factory('Messages', ['$resource',
  function($resource) {
    return $resource('/api/messages/:messageId', {
      messageId: '@_id'
    }, {
    	update: {
    		method: 'PUT'
    	}
    });
  }
]);

angular.module('mean.messages').factory('MessageDetail', function() {
	var savedData = {};
	
	function set(data) {
		savedData = data;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});

angular.module('mean.messages').factory('MessageReply', function() {
	var savedData = {};
	
	function set(data) {
		savedData = data;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});



// WEBPACK FOOTER //
// ./packages/custom/messages/public/services/messages.js